import React, { FC } from "react";
import { useFormState } from "react-final-form";
import { IWizardStepContent } from "../../../../wizard/types";
import { PreviewProgramSecondary } from "../../components/step5/PreviewProgramSecondary";

const Content: FC<IWizardStepContent> = ({ handleSubmit }) => {
  const { values } = useFormState();

  return (
    <form noValidate onSubmit={handleSubmit}>
      <PreviewProgramSecondary {...values.injectedData.data} />
    </form>
  );
};

export default Content;
